/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Credit_Note_OnlyInputs */

const en_inbound_issue_credit_note_only = /** @type {(inputs: Inbound_Issue_Credit_Note_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a distribution brand takes a credit note only`)
};

/**
* | output |
* | --- |
* | "a distribution brand takes a credit note only" |
*
* @param {Inbound_Issue_Credit_Note_OnlyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_credit_note_only = /** @type {((inputs?: Inbound_Issue_Credit_Note_OnlyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Credit_Note_OnlyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_credit_note_only(inputs)
});